import { Card, Table, OverlayTrigger, Popover, Modal } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

import callAPI from '../../../../helpers/callAPI'
import Loading from '../../../../templates/UI/Loading/Loading'
import '../../../../theme/classes.scss'
import Campaign from '../../../../templates/Campaign/Campaign'
import CampaignSetupContent from '../../../../components/CampaignSetupContent/CampaignSetupContent'

const CampaignsInSetup = ({ manager, managerType, limit, showSystemMessage, adopsDashboard = false }) => {
    const [dataLoaded, setDataLoaded] = useState(false)
    const [data, setData] = useState(false)
    const [showEditCampaignPhaseModal, setShowEditCampaignPhaseModal] = useState(false)
    const [selectedCampaignId, setSelectedCampaignId] = useState(0)    

    useEffect(() => {
        fetchData()
    }, [manager])

    const fetchData = async () => {
        setDataLoaded(false)
        let url = `campaigns/worksheetReport?ph=${managerType === 'BIZDEV' ? 10 : '20&ph2=27'}&id=${adopsDashboard ? 'All' : manager.id}&m=${managerType === 'BIZDEV' ? 'BD' : 'AAM'}`
        const data = await callAPI(url, 'GET')
        if (data.success) {
            setData(data)

        }
        setDataLoaded(true)
    }

    const handleClick = (e, campaignId) => {
        e.preventDefault()
        setSelectedCampaignId(campaignId)
       
        setShowEditCampaignPhaseModal(true)
    }

    const handleClose = (isEdited = false) => {
        setShowEditCampaignPhaseModal(false)
        if (isEdited) {
            fetchData()
        }
    }

    return (
        <Card className="mb-3">
            {dataLoaded && data && data.data.length > 0 && (
            <Modal show={showEditCampaignPhaseModal} onHide={handleClose} size="xl">
                <CampaignSetupContent 
                    closeModal={handleClose} 
                    refetch={fetchData} 
                    campaignPhaseData={data.data.find(campaign => campaign.offer_id === selectedCampaignId)} 
                />
            </Modal>
            )}
            <Card.Header className="d-flex justify-content-between align-items-center">
                <span>
                    <span className="mr-1">Campaigns in {managerType === 'BIZDEV' ? 'IO Phase' : 'Setup and Waiting Phase'}</span>
                </span>
            </Card.Header>
            <Card.Body className="p-0 overflow-auto table-container-scroll">
                <Table striped hover className="w-100 m-0 nowrap">
                    <thead>
                        <tr className="text-secondary">
                            <th width="8%">ID</th>
                            <th width="25%">Advertiser</th>
                            <th width="40%">Campaign</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataLoaded ? (
                            <>
                                {!data || data.data.length === 0 ? (
                                    <tr>
                                        <td colSpan={5}>No data.</td>
                                    </tr>
                                ) : (
                                    <>
                                        {data.data.map((campaign) => {
                                            return (
                                                <tr key={campaign.offer_id}>
                                                    <td>{campaign.offer_id}</td>
                                                    <td>
                                                        <Link to={`/advertiser/${campaign.merchant_id}`}>{campaign.merchant_name}</Link>
                                                    </td>
                                                    <td>
                                                        <Campaign oid={campaign.offer_id} name={campaign.offer_name} />
                                                    </td>
                                                    <td>{campaign.status}</td>
                                                    <td className="text-right">                                                           
                                                        <Link 
                                                            className="btn btn-warning btn-sm" 
                                                            to={`/advertiser/${campaign.merchant_id}/campaignSetup?id=${campaign.offer_id}`}
                                                            onClick={(e) => handleClick(e, campaign.offer_id)}
                                                        >
                                                            {campaign.phase_name}
                                                        </Link>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </>
                                )}
                            </>
                        ) : (
                            <tr>
                                <td colSpan={5} align="center">
                                    <Loading />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    )
}

export default CampaignsInSetup
